import { Link } from 'react-router-dom';

const posts = [
  {
    category: 'AI & Travel',
    title: 'How AI is Transforming the Travel Agency Industry in 2025',
    excerpt: 'Agencies that adopted AI early are seeing 40% more bookings. Here\'s what\'s changing and how to stay ahead.',
    date: 'Mar 18, 2025',
    readTime: '5 min read',
    slug: 'ai-transforming-travel-agency-industry-2025',
    image: 'https://public.readdy.ai/ai/img_res/aaae3cffe156d893ca98729015a22ca0.jpg',
  },
  {
    category: 'WhatsApp',
    title: 'Automating WhatsApp Bookings: A Step-by-Step Guide for Travel Agents',
    excerpt: 'WhatsApp is where your customers already are. Learn how to automate replies, confirmations, and follow-ups without losing the personal touch.',
    date: 'Mar 10, 2025',
    readTime: '7 min read',
    slug: 'automating-whatsapp-bookings-travel-agents',
    image: 'https://readdy.ai/api/search-image?query=clean%20minimalist%20workspace%20showing%20mobile%20phone%20with%20messaging%20app%20open%20professional%20desk%20setting%20muted%20neutral%20tones%20modern%20B2B%20environment&width=600&height=360&seq=blog2&orientation=landscape',
  },
  {
    category: 'Conversion',
    title: 'Increasing Booking Conversions with AI-Powered Follow-Up Sequences',
    excerpt: 'Most bookings are lost due to slow follow-up. Discover how automated sequences keep leads warm and guide them to confirmation.',
    date: 'Feb 28, 2025',
    readTime: '6 min read',
    slug: 'increasing-booking-conversions-ai-follow-up',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20analytics%20dashboard%20screen%20showing%20growth%20charts%20clean%20modern%20office%20environment%20minimalist%20design%20neutral%20background%20B2B%20SaaS&width=600&height=360&seq=blog3&orientation=landscape',
  },
];

export default function BlogPreview() {
  return (
    <section id="blog" className="py-24 md:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
          <div>
            <p className="text-sm font-medium uppercase tracking-wider mb-3 bg-gradient-to-r from-teal-500 to-indigo-500 bg-clip-text text-transparent">Blog</p>
            <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight tracking-tight">
              Insights &amp; Automation Strategies
            </h2>
          </div>
          <Link
            to="/blog"
            className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1.5"
          >
            View all posts
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((post) => (
            <Link
              key={post.title}
              to={`/blog/${post.slug}`}
              className="group bg-white border border-gray-100 rounded-xl overflow-hidden hover:border-gray-200 transition-all cursor-pointer block"
            >
              <div className="w-full h-48 overflow-hidden bg-gray-100">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col gap-3">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-gray-500 bg-gray-100 rounded-full px-2.5 py-0.5">{post.category}</span>
                  <span className="text-xs text-gray-400">{post.readTime}</span>
                </div>
                <h3 className="text-sm font-semibold text-gray-900 leading-snug group-hover:text-teal-600 transition-colors">
                  {post.title}
                </h3>
                <p className="text-xs text-gray-500 leading-relaxed">{post.excerpt}</p>
                <div className="flex items-center justify-between pt-1 border-t border-gray-50 mt-auto">
                  <span className="text-xs text-gray-400">{post.date}</span>
                  <span className="text-xs font-medium text-gray-800 flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read more <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
